import React, { useEffect, useState } from "react";
import { getAllNews } from "../../api/posts";
import { Link } from "react-router-dom";
import Pagination from "./sections/pagination";

// News Card Component
const NewsCard = ({ news }) => {
  return (
    <div className="overflow-hidden bg-white h-[500px] flex flex-col">
      <img
        src={news?.image}
        alt={news?.title}
        className="w-full h-72 object-cover"
      />
      <div className="p-5 flex flex-col flex-grow">
        <p className="text-sm text-gray-500 mb-2">
          {new Date(news?.updatedAt).toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}
        </p>
        <Link
          to={`/news/${news?._id}`}
          className="text-blue-600 font-medium hover:underline"
        >
          <h2 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
            {news?.title}
          </h2>
        </Link>
        <p className="text-gray-600 text-sm mb-4 line-clamp-4">
          {news?.paragraph}
        </p>
      </div>
    </div>
  );
};


// Main News Component
function News() {
  const [newsArticles, setNewsArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(12);
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const newsData = await getAllNews(itemsPerPage, page);
        console.log("Fetched news data:", newsData);
        setNewsArticles(newsData || []);
        setTotalItems(newsData?.length || 0);
        // console.log("Total items:", newsData?.length);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };
    fetchNews();
  }, [itemsPerPage, page]);

  return (
    <main>
      <div className="pt-32 px-4 sm:px-6 lg:px-20 bg-gray-50 min-h-screen">
        <h1 className="text-4xl font-bold mb-10 text-gray-800 text-center">
          📰 Latest News
        </h1>

        {newsArticles.length >= 0 ? (
          <>
            <div className="min-h-screen">
              <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {newsArticles.map((news) => (
                  <NewsCard key={news._id} news={news} />
                ))}
              </div>
            </div>
            <Pagination
              currentPage={page}
              itemsPerPage={itemsPerPage}
              totalItems={totalItems}
              onPageChange={(p) => setPage(p)}
              onItemsPerPageChange={(num) => {
                setItemsPerPage(num);
                setPage(1); // reset to first page
              }}
            />
          </>
        ) : (
          <p className="text-center text-gray-500 text-lg">No news available.</p>
        )}

      </div>
    </main>
  );
}

export default News;
